// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as RecordsWrapper from "./RecordsWrapper.bs.js";
import * as Accordion$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/Accordion.bs.js";
import * as NLOrderStatusInfoVm from "./vm-mapper/NLOrderStatusInfoVm.bs.js";
import * as AccordionTypes$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/accordion/AccordionTypes.bs.js";
import * as CardRowViewMapper$Catalyst from "../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/cards/CardRowViewMapper.bs.js";

function getViewLabel(statuses) {
  return {
          hd: {
            label: "Dry Run Distance",
            value: {
              TAG: /* Text */0,
              _0: statuses.dry_run_distance
            }
          },
          tl: {
            hd: {
              label: "Start Location",
              value: {
                TAG: /* Text */0,
                _0: statuses.start_location
              }
            },
            tl: {
              hd: {
                label: "Driver Location Accuracy",
                value: {
                  TAG: /* Text */0,
                  _0: statuses.driver_location_accuracy
                }
              },
              tl: {
                hd: {
                  label: "Trip Ended Location",
                  value: {
                    TAG: /* Text */0,
                    _0: statuses.trip_ended_location
                  }
                },
                tl: {
                  hd: {
                    label: "Accepted Location",
                    value: {
                      TAG: /* Text */0,
                      _0: statuses.accepted_location
                    }
                  },
                  tl: {
                    hd: {
                      label: "Start Location Coordinates",
                      value: {
                        TAG: /* Text */0,
                        _0: statuses.start_lat_long
                      }
                    },
                    tl: {
                      hd: {
                        label: "Cancellation Source",
                        value: {
                          TAG: /* Text */0,
                          _0: statuses.cancellation_source
                        }
                      },
                      tl: {
                        hd: {
                          label: "Trip Ended Location Coordinates",
                          value: {
                            TAG: /* Text */0,
                            _0: statuses.trip_ended_lat_long
                          }
                        },
                        tl: {
                          hd: {
                            label: "Cancellation/Reschedule Reason",
                            value: {
                              TAG: /* Text */0,
                              _0: statuses.cancellation_reschedule_reason
                            }
                          },
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        };
}

function NLOrderStatusInfo(Props) {
  var order = Props.order;
  var statuses = NLOrderStatusInfoVm.getVm(order);
  return React.createElement(Accordion$Catalyst.make, {
              panels: {
                hd: AccordionTypes$Catalyst.make_props({
                      TAG: /* Text */0,
                      _0: "Order Status Information"
                    }, undefined, undefined, React.createElement(RecordsWrapper.make, {
                          children: CardRowViewMapper$Catalyst.CardRecordView.make("record", getViewLabel(statuses))
                        }), undefined),
                tl: /* [] */0
              },
              className: "c-nlo-accordion-cmp"
            });
}

var make = NLOrderStatusInfo;

export {
  getViewLabel ,
  make ,
  
}
/* react Not a pure module */
